export default __webpack_public_path__ + "static/media/signal-3.5f145dd2.svg";